<script lang="ts">
  import InboxWorkflowPreconfigurationBox from "@kontextwerk/control-web-frame/shared/modules/inbox-workflow-preconfiguration-box"
  import type {
      InboxWorkflowJson,
      InboxWorkflowPreconfigurationProps,
      InboxWorkflowTableRuntimeRow,
  } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import {
      notifyInboxWorkflowPreconfigurationApplyResult,
      resolveInboxWorkflowPreconfigurationTargets,
  } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import {
    isKeepPreconfigurationChoice,
    withKeepPreconfigurationOption,
    type PreconfigurationChoice,
  } from "../../../../../../../../../_shared/_logic/preconfiguration-keep"

  type SourceCleanupValue = "not_done" | "done"

  let {
    rows,
    selectedIds,
    patchRows,
    disabled = false,
  }: InboxWorkflowPreconfigurationProps<InboxWorkflowTableRuntimeRow, InboxWorkflowJson> = $props()

  // Every open row starts as not done, so "Nein" leaves the table unchanged.
  let completion = $state<PreconfigurationChoice<SourceCleanupValue>>("not_done")

  const targetResolution = $derived(
    resolveInboxWorkflowPreconfigurationTargets({
      rows,
      selectedIds,
      getId: (row) => row.id,
      isEligible: (row) => !row.disabled,
    }),
  )

  const apply = () => {
    if (!isKeepPreconfigurationChoice(completion)) {
      patchRows(targetResolution.targetRows, { completed: completion === "done" })
    }

    notifyInboxWorkflowPreconfigurationApplyResult({
      total: targetResolution.targetRows.length + targetResolution.skippedRows.length,
      applied: targetResolution.targetRows.length,
      skipped: targetResolution.skippedRows.length,
    })
  }
</script>

<InboxWorkflowPreconfigurationBox
  selectedCount={selectedIds.length}
  targetCount={targetResolution.targetRows.length}
  {disabled}
  onApply={apply}
>
  <div class="preconfiguration-grid">
    <Input
      type="select"
      label="Nachträge markieren als"
      bind:value={completion}
      brightBackground={false}
      surfaceTone="dark"
      options={withKeepPreconfigurationOption([
        { value: "not_done", name: "Alle als Nein markieren" },
        { value: "done", name: "Alle als Ja markieren" },
      ])}
    />
  </div>
</InboxWorkflowPreconfigurationBox>

<style>
  .preconfiguration-grid {
    padding-top: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(12rem, 1fr);
    max-width: 32rem;
  }
</style>
